import { Button } from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"
import { PracticeStatus } from "@/entities/behavioral-goal"
import CheckMarkGray from "@/svgs/CheckMarkGray"

import { BehavioralPracticeStatus } from "../../consts"

import "./styles.scss"

type Props = {
    status: PracticeStatus
    className?: string
    onClick: () => void
}

const BehavioralStatus = ({ status, onClick, className }: Props) => {
    return (
        <Button
            isContainer
            className={buildCssClassName("p-0 behavioral-practice-card-btn-status", className)}
            onClick={onClick}
            data-btn="btn-status"
        >
            <div
                className={buildCssClassName("behavioral-practice-card-status d-flex align-items-center", {
                    queued: status === BehavioralPracticeStatus.Queued,
                    active: status === BehavioralPracticeStatus.Active,
                    done: status === BehavioralPracticeStatus.Done
                })}
            >
                <span className="flex-1">{status}</span>
                {status === BehavioralPracticeStatus.Done && (
                    <span className="ml-1 d-flex align-items-center">
                        <CheckMarkGray />
                    </span>
                )}
            </div>
        </Button>
    )
}

export default BehavioralStatus
